import React from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { Contact } from "./FrontEnd/Contacts/Contact";
import { ContactList } from "./FrontEnd/Contacts/ContactList";
import { Lead } from "./FrontEnd/Masters/Lead/Lead";
import { LeadList } from "./FrontEnd/Masters/Lead/LeadList";
import ParentComponent from "./FrontEnd/testdynamic";

import { CreateDeals } from "./FrontEnd/Common/Deals/Create/CreateDeals";
import { CreateMeeting } from "./FrontEnd/Common/Deals/Create/CreateMeeting";
import { CreateTask } from "./FrontEnd/Common/Deals/Create/CreateTask";
import { DealList } from "./FrontEnd/Common/Deals/DealList";
import { TaskList } from "./FrontEnd/Common/TaskList";
import { ContactDeatails } from "./FrontEnd/Contacts/ContactDetails/ContactDeatails";
import { Estimation } from "./FrontEnd/Estimation/Estimation";
import { EstimationList } from "./FrontEnd/Estimation/EstimationList";
import { LeadDetails } from "./FrontEnd/Masters/LeadDetails/LeadDeatails";
import { Orders } from "./FrontEnd/Orders/Orders";
import { Quote } from "./FrontEnd/Quatation/Quatation";
import { QuoteList } from "./FrontEnd/Quatation/QuatationList";
import { UserManagement } from "./FrontEnd/Users/UserRegistration";

import { CallLogList } from "./FrontEnd/Common/CallLogList";
import { CreateCallLog } from "./FrontEnd/Common/Deals/Create/CreateCallLog";
import { CreateNotes } from "./FrontEnd/Common/Deals/Create/CreateNotes";
import { NotesList } from "./FrontEnd/Common/NotesList";
import { UserList } from "./FrontEnd/Users/UserList";
import { CreateRole } from "./FrontEnd/Roles/CreateRole";
import { RoleList } from "./FrontEnd/Roles/RoleList";
import { MeetingList } from "./FrontEnd/Common/Deals/MeetingList";
import { LeadStatus } from "./FrontEnd/Masters/LeadStatus/LeadStatus";
import MainDashboard from "./FrontEnd/Dashboard";

import Visit from "./FrontEnd/Visiting/Visit";
import { SurvayList } from "./FrontEnd/SolarSiteSurvey/SurveyList";
import { SolarSiteSurveyForm } from "./FrontEnd/SolarSiteSurvey/Survey";
import QuickLinks from "./FrontEnd/QuickLinks/QuickLinks";


interface PrivateRouteProps {
  token: string | null;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ token }) => {
  if (!token) {
    return token ? <Outlet /> : <Navigate to="/login" />;
  }

  return (
    <Routes>
      {/* <Route path="/" element={<Layout />}/> */}
      <Route path="/leads/list" element={<LeadList />} />
      <Route path="/home" element={<MainDashboard />} />
      <Route path="/leads/create" element={<Lead />} />
      {/* <Route path="/leads/edit/:id" element={<LeadEdit/>}/> */}
      <Route path="/leads/edit/:id" element={<LeadDetails />} />

      <Route path="/contacts/list" element={<ContactList />} />
      <Route path="/contact/create" element={<Contact />} />
      <Route path="/contact/edit/:id" element={<ContactDeatails />} />

      <Route path="/deals/list" element={<DealList />} />
      <Route path="/deal/create" element={<CreateDeals />} />
      <Route path="/deal/edit/:id" element={<CreateDeals />} />

      {/* Quotations */}
      <Route path="/quatation/list" element={<QuoteList />} />
      <Route path="/quatation/:id?" element={<Quote />} />
      {/* <Route path="/quatation/print/:id?" element={<QPrint />} /> */}


      <Route path="/survey/list" element={<SurvayList />} />
      <Route path="/survey/:id?" element={<SolarSiteSurveyForm />} />

      <Route path="/user/list" element={<UserList />} />
      <Route path="/user/registration" element={<UserManagement />} />
      <Route path="/user/registration/edit/:id" element={<UserManagement />} />


      <Route path="/test" element={<ParentComponent />} />

      <Route path="/meeting/list" element={<MeetingList />} />
      <Route path="/meeting/create" element={<CreateMeeting />} />
      <Route path="/meeting/edit/:id" element={<CreateMeeting />} />

      <Route path="/task/list" element={<TaskList />} />
      <Route path="/task/create" element={<CreateTask />} />
      <Route path="/task/edit/:id" element={<CreateTask />} />


      <Route path="/note/list" element={<NotesList />} />
      <Route path="/note/create" element={<CreateNotes />} />
      <Route path="/note/edit/:id" element={<CreateNotes />} />

      <Route path="/call/list" element={<CallLogList />} />
      <Route path="/call/create" element={< CreateCallLog />} />
      <Route path="/call/edit/:id" element={<CreateCallLog />} />
      {/* Estimation */}
      <Route path="/estimation/list" element={<EstimationList />} />
      <Route path="/contact/edit/:id/estimation/:estId?" element={<Estimation />} />
      <Route path="/contact/edit/:id/quatation/:quId?" element={<Quote />} />
      <Route path="/contact/edit/:id/order/:orderId?" element={<Orders />} />
      <Route path="/contact/edit/:id/quatation/convert-quatation/:estimatId?" element={<Quote />} />
      {/* <Route path="/estimation/print/:id?" element={<EPrint />} /> */}
      <Route path="/contact/edit/:id/order/convert-order/:quatationId?" element={<Orders />} />
      {/* Orders */}
      <Route path="/role/list" element={<RoleList />} />
      <Route path="/role/create" element={<CreateRole />} />
      <Route path="/role/edit/:id" element={<CreateRole />} />

      <Route path="/visit/:id?/date/:date?" element={<Visit />} />
      {/* lead status */}
      {/* <Route path="/lead-status/create" element={<LeadStatus />} />
      <Route path="/lead-status/edit/:id" element={<LeadStatus />} /> */}
      <Route path="/links/quick" element={<QuickLinks />} />
    </Routes>
  );
};

export default PrivateRoute;
